module.exports = __webpack_public_path__ + "img/valyoo-logo-blanco.98a64419.svg";